package nl.astraeus.wiki.messages

class RemovePageMessage() : Message(
  MessageType.REMOVE_PAGE,
  MessageHeader.PAGE_ID,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(pageId: Long) : this() {
    setHeader(MessageHeader.PAGE_ID, pageId.toString())
  }

}
